import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { Modal, Pagination } from 'react-bootstrap';
import { getPriceUnitAction, deletePriceUnitAction, createPriceUnitAction, updatePriceUnitAction } from '../../store/actions/PriceUnit/PriceUnitActions';

const PriceUnit = () => {
	const dispatch = useDispatch();

	// Use correct reducer and loading state
	const { priceUnit, loading } = useSelector((state) => state.priceUnit);
	const priceUnitRows = priceUnit?.rows || [];
	const totalPages = priceUnit?.pages || 1;
	const [formErrors, setFormErrors] = useState({});
	const [searchTerm, setSearchTerm] = useState('');

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize] = useState(10);
	const [addCard, setAddCard] = useState(false);

	const [addFormData, setAddFormData] = useState({
		name: '',
		isEnabled: true
	});

	const [editMode, setEditMode] = useState(false);
	const [editpropertyTypeData, setEditpropertyTypeData] = useState(null);

	const handleAddFormChange = (input) => {
		if (input?.target) {
			// Native input event
			const { name, value } = input.target;
			setAddFormData((prev) => ({
				...prev,
				[name]: name === "isEnabled" ? value === "true" : value
			}));

			setFormErrors((prevErrors) => ({
				...prevErrors,
				[name]: ''
			}));
		}
	};

	const handleAddFormSubmit = async (event) => {
		event.preventDefault();

		const { name } = addFormData;
		const errors = {};

		if (!name.trim()) errors.name = "Name is required.";

		setFormErrors(errors);

		if (Object.keys(errors).length > 0) return;

		const payload = {
			name,
			isEnabled: addFormData.isEnabled
		};

		try {
			let response;
			if (editMode && editpropertyTypeData?._id) {
				response = await dispatch(updatePriceUnitAction(editpropertyTypeData._id, payload));
			} else {
				response = await dispatch(createPriceUnitAction(payload));
			}

			if (response.data.success) {
				Swal.fire({ icon: 'success', title: 'Success!', text: editMode ? 'Price Unit updated' : 'Price Unit status added' });
				resetForm();
				dispatch(getPriceUnitAction(currentPage, pageSize, searchTerm));
			} else {
				Swal.fire({ icon: 'error', title: 'Error', text: response.data?.msg || 'Something went wrong' });
			}
		} catch (error) {
			Swal.fire({ icon: 'error', title: 'Error', text: error?.response?.data?.msg || 'Unexpected error occurred' });
		}
	};

	const handleDelete = async (policyId) => {
		const result = await Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, delete it!"
		});

		if (result.isConfirmed) {
			const response = await dispatch(deletePriceUnitAction(policyId));
			if (response.data.success) {
				Swal.fire("Deleted!", "The Price Unit has been deleted.", "success");
				dispatch(getPriceUnitAction(currentPage, pageSize, searchTerm));
			} else {
				Swal.fire("Deleted!", "Check.", "Test");
			}
		}
	};

	const handleEdit = (data) => {
		setEditMode(true);
		setEditpropertyTypeData(data);
		setFormErrors({});
		setAddFormData({
			name: data.name,
			isEnabled: data.isEnabled
		});
		setAddCard(true);
	};

	const resetForm = () => {
		setAddCard(false);
		setEditMode(false);
		setEditpropertyTypeData(null);
		setAddFormData({
			name: '',
			isEnabled: true
		});
	};

	const searchRole = () => {
		dispatch(getPriceUnitAction(currentPage, pageSize, searchTerm));
	}

	useEffect(() => {
		dispatch(getPriceUnitAction(currentPage, pageSize, searchTerm));
	}, [dispatch, currentPage, pageSize, searchTerm]);

	return (
		<>
			<div className="col-12">
				<Modal className="modal fade" show={addCard} onHide={resetForm}>
					<form onSubmit={handleAddFormSubmit}>
						<div className="modal-header">
							<h4 className="modal-title fs-20">{editMode ? 'Edit Price Unit' : 'Add Price Unit'}</h4>
							<button type="button" className="btn-close" onClick={resetForm}></button>
						</div>
						<div className="modal-body">
							<div className="add-contact-box">
								<div className="add-contact-content">
									<div className="form-group mb-3">
										<label>Name</label>
										<input type="text" className={`form-control ${formErrors.name ? 'is-invalid' : ''}`} name="name" value={addFormData.name} onChange={handleAddFormChange} placeholder="Name"  />
										{formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
									</div>
									<div className="form-group mb-3">
										<label>Status</label>
										<select name="isEnabled" className={`form-control ${formErrors.isEnabled ? 'is-invalid' : ''}`} value={addFormData.isEnabled} onChange={handleAddFormChange}>
											<option value={true}>Enabled</option>
											<option value={false}>Disabled</option>
										</select>
										{formErrors.isEnabled && <div className="invalid-feedback">{formErrors.isEnabled}</div>}
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="submit" className="btn btn-primary">{editMode ? "Update" : "Add"}</button>
							<button type="button" onClick={resetForm} className="btn btn-danger">Discard</button>
						</div>
					</form>
				</Modal>

				<div className="card">
					<div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-3">
						<h4 className="card-title mb-0">Price Unit List</h4>
						
						<div className="input-group w-50">
							<input
								type="text"
								className="form-control"
								placeholder="Search by name..."
								onChange={(e) => setSearchTerm(e.target.value)} 
								onKeyDown={(e) => {
									if (e.key === 'Enter') {
										searchRole();
									}
								}}
							/>
							<span onClick={searchRole} className="input-group-text" style={{ cursor: 'pointer' }}>
								<i className="fa fa-search"></i>
							</span>
						</div>

						<button className="btn btn-primary shadow btn-xs sharp me-2" onClick={() => setAddCard(true)}>
							<i className="fa fa-plus"></i>
						</button>
					</div>
					<div className="card-body">
						<div className="table-responsive">
							<table className="table table-striped">
								<thead>
									<tr>
										<th>Name</th>
										<th>Enabled</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>
									{loading ? (
										// Skeleton loader rows
										Array.from({ length: 5 }).map((_, idx) => (
											<tr key={idx}>
												<td><span className="skeleton-box" style={{ width: '80px', height: '20px', display: 'inline-block' }} /></td>
												<td><span className="skeleton-box" style={{ width: '60px', height: '20px', display: 'inline-block' }} /></td>
												<td><span className="skeleton-box" style={{ width: '100px', height: '20px', display: 'inline-block' }} /></td>
											</tr>
										))
									) : priceUnitRows.length === 0 ? (
										<tr>
											<td colSpan={3} className="text-center text-muted">No price units found</td>
										</tr>
									) : (
										priceUnitRows.map((policy) => (
											<tr key={policy._id}>
												<td>{policy.name}</td>
												<td className={policy.isEnabled ? 'text-success' : 'text-danger'}>
													{policy.isEnabled ? 'True' : 'False'}
												</td>
												<td>
													<div className="d-flex">
														<button className="btn btn-secondary shadow btn-xs sharp me-2" onClick={() => handleEdit(policy)}>
															<i className="fa fa-pencil"></i>
														</button>
														<button className="btn btn-danger shadow btn-xs sharp" onClick={() => handleDelete(policy._id)}>
															<i className="fa fa-trash"></i>
														</button>
													</div>
												</td>
											</tr>
										))
									)}
								</tbody>
							</table>
						</div>

						<div className="d-flex justify-content-between align-items-center mt-4">
							<div></div> {/* Empty div to align right side content */}
							<div className="d-flex align-items-center gap-3">
								<span className="text-muted">Total Price Units: {priceUnit?.total || priceUnitRows.length}</span>
								<Pagination className="pagination-gutter pagination-circle pagination mb-0">
									<Pagination.Prev
										disabled={currentPage === 1}
										onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
									/>
									{Array.from({ length: totalPages }, (_, i) => (
										<Pagination.Item
											key={i + 1}
											active={i + 1 === currentPage}
											onClick={() => setCurrentPage(i + 1)}
										>
											{i + 1}
										</Pagination.Item>
									))}
									<Pagination.Next
										disabled={currentPage === totalPages}
										onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
									/>
								</Pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PriceUnit;
